<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
            {{ $tc('centers.title', 2) }}
          </label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="centerFilter"
            :options="centerOptions"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:centerFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="center-filter"
          />
      </b-col>
      <b-col cols="6" class="mb-2">
      <label class="text-capitalize">
          {{ $tc('sectors.title', 2) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorFilter"
          :options="sectorOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:sectorFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="sector-filter"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc('tenants.title', 1) }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="tenantFilter"
            :options="tenantOptions"
            class="w-100"
            multiple
            :reduce="val => val.value"
            @input="(val) => $emit('update:tenantFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="tenant-filter"
          />
      </b-col>
      <b-col
        cols="6"
        class="mb-2"
      >
      <label class="text-capitalize">{{ $tc('vxg_master_account.title', 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="securosMasterAccountFilter"
          :options="securosMasterAccountOptions"
          class="w-100"
          multiple
          :reduce="val => val.value"
          @input="(val) => $emit('update:securosMasterAccountFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="securos-master-account-filter"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2 text-capitalize">
        <label class="text-capitalize">{{ $t('camera.online') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="onlineFilter"
            class="w-100"
            :reduce="val => val.value"
            :options="[{label: 'online', value: true}, {label: 'offline', value: false}]"
            @input="(val) => $emit('update:onlineFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="online-filter"
          />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('camera_proxy.rtsp_available') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="rtspAvailableFilter"
            class="w-100"
            :reduce="val => val.value"
            :options="[{label: 'enabled', value: true}, {label: 'disabled', value: false}]"
            @input="(val) => $emit('update:rtspAvailableFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="rtsp-available-filter"
          />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2 text-capitalize">
        <label class="text-capitalize">{{ $t('vxg_camera.events_enabled') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="eventsEnabledFilter"
            class="w-100"
            :reduce="val => val.value"
            :options="[{label: 'online', value: true}, {label: 'offline', value: false}]"
            @input="(val) => $emit('update:eventsEnabledFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="events-enabled-filter"
          />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('vxg_camera.register_type') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="registerTypeFilter"
            class="w-100"
            :options="['normal', 'uplink']"
            @input="(val) => $emit('update:registerTypeFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="register-type-filter"
          />
      </b-col>
      <!-- Format Stream -->
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('vxg_camera.format_stream') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="streamFormatsFilter"
            :options="streamFormatsOptions"
            class="w-100"
            multiple
            @input="(val) => $emit('update:streamFormatsFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="format-stream-filter"
          />
      </b-col>
      <!-- Resolution Stream -->
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('vxg_camera.resolution_stream') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="streamResolutionsFilter"
            :options="streamResolutionsOptions"
            class="w-100"
            multiple
            @input="(val) => $emit('update:streamResolutionsFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="resolution-stream-filter"
          />
      </b-col>
      <!-- FPS -->
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('vxg_camera.fps') }}</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="fpsFilter"
            :options="fpsOptions"
            class="w-100"
            :reduce="val => val"
            @input="(val) => $emit('update:fpsFilter', val)"
            append-to-body
            :calculate-position="withPopper"
            data-cy="fps-filter"
          />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormCheckbox,
    vSelect,
  },
  props: {
    centerOptions: {
      type: Array,
      default: null,
    },
    centerFilter: {
      type: Array,
      default: null,
    },
    sectorOptions: {
      type: Array,
      default: null,
    },
    sectorFilter: {
      type: Array,
      default: null,
    },
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    securosMasterAccountOptions: {
      type: Array,
      default: null,
    },
    securosMasterAccountFilter: {
      type: Array,
      default: null,
    },
    onlineFilter: {
      type: Boolean,
      default: false,
    },
    rtspAvailableFilter: {
      type: Boolean,
      default: false,
    },
    buttonUpdate: {
      type: Boolean,
      default: false,
    },
    eventsEnabledFilter: {
      type: Boolean,
      default: false,
    },
    registerTypeFilter: {
      type: String,
      default: null
    },
    streamFormatsOptions: {
      type: Array,
      default: null,
    },
    streamFormatsFilter: {
      type: Array,
      default: () => [],
    },
    streamResolutionsOptions: {
      type: Array,
      default: null,
    },
    streamResolutionsFilter: {
      type: Array,
      default: () => [],
    },
    fpsOptions: {
      type: Array,
      default: null,
    },
    fpsFilter: {
      type: Object,
      default: null,
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    }
  },
};
</script>
